import { CLOSE_STATUS_BAR, SHOW_STATUS_BAR } from '../constants/actions';

const DEFAULT_STATUS_BAR_STATE = {
  action_button_value: '',
  message: '',
  showing: false,
  title: '',
};

const statusBarReducer = (state = DEFAULT_STATUS_BAR_STATE, action) => {
  switch (action.type) {
    case CLOSE_STATUS_BAR:
      return DEFAULT_STATUS_BAR_STATE;
    case SHOW_STATUS_BAR:
      return {
        ...state,
        action_button_value: action.actionButtonValue,
        message: action.message,
        showing: true,
        title: action.title,
      };
    default:
      return state;
  }
};

export default statusBarReducer;
